import { render, staticRenderFns } from "./BbppModeloBancaPremium.vue?vue&type=template&id=643dbb1a"
import script from "./BbppModeloBancaPremium.vue?vue&type=script&lang=js"
export * from "./BbppModeloBancaPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports